'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MockGeolocatedDynamicMap = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactGeolocated = require('react-geolocated');

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint react/prefer-stateless-function: 0 */
/* Cannot be stateless because of Geolocation */

var GeolocatedDynamicMap = function (_Component) {
  (0, _inherits3.default)(GeolocatedDynamicMap, _Component);

  function GeolocatedDynamicMap() {
    (0, _classCallCheck3.default)(this, GeolocatedDynamicMap);
    return (0, _possibleConstructorReturn3.default)(this, (GeolocatedDynamicMap.__proto__ || (0, _getPrototypeOf2.default)(GeolocatedDynamicMap)).apply(this, arguments));
  }

  (0, _createClass3.default)(GeolocatedDynamicMap, [{
    key: 'render',
    value: function render() {
      var mapProperties = (0, _assign2.default)({}, this.props.mapProps);

      if (this.props.isGeolocationEnabled && this.props.coords) {
        var _props$coords = this.props.coords,
            latitude = _props$coords.latitude,
            longitude = _props$coords.longitude;

        if (latitude) {
          mapProperties.geoLatitude = latitude;
        }
        if (longitude) {
          mapProperties.geoLongitude = longitude;
        }
      }

      return _react2.default.createElement(_.DynamicMap, mapProperties);
    }
  }]);
  return GeolocatedDynamicMap;
}(_react.Component);

GeolocatedDynamicMap.propTypes = {
  /**
   * A coords object provided by the Geolocation API
   * Provided by a wrapper component by default, no need to specify.
   */
  coords: _propTypes2.default.object,
  /**
   * A boolean that indicated if the browser supports and has enabled Geolocation.
   * Provided by a wrapper component by default, no need to specify.
   */
  isGeolocationEnabled: _propTypes2.default.bool,
  /**
   * The properties to pass-through to the DynamicMap
   */
  mapProps: _propTypes2.default.object.isRequired
};
exports.default = (0, _reactGeolocated.geolocated)({
  userDecisionTimeout: 5000
})(GeolocatedDynamicMap);


var MockGeolocatedDynamicMap = (0, _reactGeolocated.geolocated)({
  userDecisionTimeout: 5000,
  geolocationProvider: {
    getCurrentPosition: function getCurrentPosition(onSuccess) {
      return onSuccess({
        coords: {
          latitude: 50,
          longitude: 20
        }
      });
    },
    watchPosition: function watchPosition(onSuccess) {
      return onSuccess({
        coords: {
          latitude: 50,
          longitude: 20
        }
      });
    }
  }
})(GeolocatedDynamicMap);
exports.MockGeolocatedDynamicMap = MockGeolocatedDynamicMap;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/GeolocatedDynamicMap.js
// module id = 276
// module chunks = 0